<form>
  <img src="assets/img/svg/esmart-logo.svg" alt="EMP Logo" />

  <img class="robot-img" src="assets/img/svg/robot-circle.svg" />

  <h3>{{ 'LOGIN__RESET_PASSWORD' | translate }}</h3>

  <mat-form-field subscriptSizing="dynamic">
    <mat-label>{{ 'EMAIL' | translate }}</mat-label>
    <input [formControl]="emailControl" matInput type="email" />

    @if (emailControl.hasError('required')) {
      <mat-error>
        {{ 'FORM__ERROR__REQUIRED' | translate }}
      </mat-error>
    }

    @if (emailControl.hasError('email')) {
      <mat-error>
        {{ 'FORM__ERROR__INVALID_EMAIL' | translate }}
      </mat-error>
    }
  </mat-form-field>

  <button (click)="onSubmit()" class="es-btn es-btn-lg es-btn-accented">
    {{ 'SEND' | translate | uppercase }}
  </button>
</form>
